<template>
	<li :class="classValue">
		<slot />
	</li>
</template>
<script>
export default {
	props:["classValue"]
}
</script>